import React from "react";
import Container from "../../components/Container";
export default function NotFound() {
  return <Container>Página não encontrada</Container>;
}
